import { buildCrudRoutes } from '@/app/arch/components/crud/CrudRouter';
import moduleBreadcrumbs from 'Modules/contacard/moduleBreadcrumbs';

export default [
  ...buildCrudRoutes({
    baseName: 'analysisTable',
    basePath: 'analysis-table',
    baseBreadcrumbs: [
      ...moduleBreadcrumbs,
    ],
    card: {
      title: 'Mesa de análise',
      icon: '',
    },
    moduleActive: 'contacard',
    listRoute: {
      pageContent: () => import('Modules/contacard/analysisTable/AnalysisTableList.vue'),
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
      speedFilter: () => import('Modules/contacard/analysisTable/components/filters/AnalysisTableSpeedFilters.vue'),
      filterComponent: () => import('Modules/contacard/analysisTable/components/filters/AnalysisTableFilter.vue'),
      searchOptions: { label: 'Buscar cliente', searchAttribute: 'search' },
      pageTitle: 'Mesa de análise',
      navigateBackRoute: 'contacard.submodules.list',
    },
    editRoute: {
      component: () => import('Modules/contacard/analysisTable/AnalysisTableForm.vue'),
      breadcrumbs: [
        {
          text: 'Análise cadastral',
          disabled: true,
        },
      ],
    },
  }),
];
